<template>
  <svg
    width="16"
    height="16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  ><path
    d="M2 8.167a6.333 6.333 0 1 0 12.666 0A6.333 6.333 0 0 0 2 8.167v0Z"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  /></svg>
</template>
